import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaWhatsapp } from "react-icons/fa";
import "./HomeBanner.css";

const HomeBanner = () => {
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get("https://api.swasthmitra.com/api/banners");
        setBanners(response.data);
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    fetchBanners();
  }, []);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      goToNext();
    }, 5000);

    return () => clearInterval(intervalId);
  }, [banners]);

  return (
    <section className="home-banners">
      <div className="carousel-container">
        <div
          className="banners-wrapper"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {banners.map((banner) => (
            <div key={banner._id} className="banner-item">
              <img src={banner.image} alt={banner.title} />
              <div className="banner-content">
                <h2>{banner.title}</h2>
                <p>{banner.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div
          className={`whatsapp-icon ${showPopup ? "show-popup" : ""}`}
          onClick={() => setShowPopup(!showPopup)}
        >
          <FaWhatsapp size={32} />
        </div>
        {showPopup && (
          <div className={`whatsapp-popup ${showPopup ? "show-popup" : ""}`}>
            <p>Book an Appointment</p>
            <p>
  <a href="https://wa.me/919118063939" target="_blank" style={{color:'black', textDecoration:'none',fontWeight:'500'}}>Click Here</a>
</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default HomeBanner;
